module.exports = __webpack_public_path__ + "img/avatar.33d54978.png";